import React, { useMemo } from 'react';
import DefaultDetails from './email-details';
import { observer } from 'mobx-react';

function EmailDetailsFactory({ ui, ...rest }) {
    const Component = useMemo(() => {
        return DefaultDetails;
        // switch (ui.variant) {
        //     // case "some":
        //     //   return SOMEOTHERDETAILS;  // put here some rule to choose the right component
        //     default:
        //         return DefaultDetails;
        // }
    }, [JSON.stringify(ui)]);

    return <Component presentation={ui} {...rest} />;
}

export default observer(EmailDetailsFactory);
